



export default class {
    constructor(windowPal, $body) {
        this.windowPal = windowPal;
        this.$body = $body;
        this.$applyJobBtn = $("#job-apply-btn");
        this.$blueBox = $(".blue-box");

        if (this.$applyJobBtn.length && this.$blueBox.length) {
    // console.log({
    //     'blueBoxoffsetTop' : this.$blueBox[0].offsetTop,
    //     'blueBoxHeight' : this.$blueBox[0].offsetHeight,
    //     'applyBtnHeight' : this.$applyJobBtn[0].offsetHeight
    // })
            this.threshold = Math.abs((this.$blueBox[0].offsetHeight - this.$blueBox[0].offsetTop) + this.$applyJobBtn[0].offsetHeight);
            windowPal.resize(() => {
                this.resize();
            });
            windowPal.scroll(() => {
                this.scroll();
            });
            this.resize();
            this.scroll();
        }
    }

    scroll() {
        let pos = this.windowPal.$.scrollTop();
        //console.log(pos, this.threshold);

        if (pos < this.threshold) {
            $(this.$applyJobBtn).removeClass("relative");
        }
        if (pos >= this.threshold) {
            $(this.$applyJobBtn).addClass("relative");
        }
    }

    resize() {
        this.threshold = Math.abs((this.$blueBox[0].offsetHeight - this.$blueBox[0].offsetTop) + this.$applyJobBtn[0].offsetHeight);
    }
}


// WEBPACK FOOTER //
// ./scripts/lib/StickyApplyJobBtn.js